import type { TableRowType } from '../components/editor/grid/reduxStore/table.types';

export const CELL_BACKGROUND_COLOR_VARIABLE = '--py-cell-background-color';

const HEX_COLOR_PATTERN = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

// Escapes a value for a double-quoted CSS attribute selector string, including control characters such as newlines,
// which would otherwise end the string and make the browser drop the rule.
export const escapeAttributeValue = (value: string) =>
  value
    .replace(/["\\]/g, '\\$&')
    // eslint-disable-next-line no-control-regex -- matching control characters is the point
    .replace(/[\u0000-\u001f\u007f]/g, (character) => `\\${character.charCodeAt(0).toString(16)} `);

// Scopes each cell's background colour to one table by setting a CSS variable that the theme's cell rule reads, so
// editor states (hidden cell, column selection, focus) keep precedence over the cell colour.
export const getCellBackgroundColorStyles = (rows: Pick<TableRowType, 'id' | 'cellConfig'>[], scopeSelector: string) => {
  const rules: Record<string, Record<string, string>> = {};

  rows.forEach((row) => {
    Object.entries(row.cellConfig ?? {}).forEach(([field, config]) => {
      const backgroundColor = config?.styles?.backgroundColor;
      if (typeof backgroundColor !== 'string' || !HEX_COLOR_PATTERN.test(backgroundColor)) return;

      const rowSelector = `.MuiDataGrid-row[data-id="${escapeAttributeValue(String(row.id))}"]`;
      const cellSelector = `.MuiDataGrid-cell[data-field="${escapeAttributeValue(field)}"]`;
      rules[`${scopeSelector} ${rowSelector} ${cellSelector}`] = { [CELL_BACKGROUND_COLOR_VARIABLE]: backgroundColor };
    });
  });

  return rules;
};
